module.exports = __webpack_public_path__ + "img/home.2833a8f3.jpg";